@if (isVisible()) {
  <header class="glass-header">
    <div class="header-content">

      <div class="left-slot">
        @if (showBack()) {
          <button (click)="goBack()" class="header-badge-btn">
            @if (this.backRoute()) {
              <svg lucideHome></svg>
            } @else {
              <svg lucideChevronLeft></svg>
            }
          </button>
        } @else {
          @if (selectedTable()) {
            <div class="header-badge-indicator">

              <svg lucideHandPlatter></svg>
              <span>{{ selectedTable() }}</span>
            </div>
          }
        }
      </div>

      <div class="header-center">
        @if (customerName()) {
          <span class="welcome-text">Hola, <strong>{{ customerName() }}</strong></span>
        } @else {
          <h1 class="header-title">{{ title() }}</h1>
        }
      </div>

      <div class="right-slot">
        <div class="cart-group">

          @if (orderRestaurantId()) {
            <button (click)="goToTracking()" class="header-badge-btn">
              <svg lucideReceipt></svg>
            </button>
          }

          @if (cartCount() > 0) {
            <button (click)="goToCart()" class="header-badge-btn cart-btn">
              <svg lucideShoppingCart></svg>
              <span class="cart-badge">{{ cartCount() }}</span>
            </button>
          }

        </div>
      </div>

    </div>
  </header>
}
